import { AWSRegions } from "../generated/ups/graphql";

export type UserType = {
  email: string;
  firstName: string;
  lastName: string;
  groups: string[];
  roles: string[];
  status: string;
  username: string;
  attributes: Record<string, string>;
};

export type GetUserRequestType = {
  region: AWSRegions;
  username: string;
};

export type GetUserParams = { username: string; region: AWSRegions };

export type AuthRefreshTokenMutationVariables = {
  refreshToken: string;
  region: string;
};

export type AuthRefreshTokenMutationResponse = {
  authRefreshToken: {
    accessToken: string;
    refreshToken: string;
    idToken: string;
  };
};

export enum UserSearchParam {
  REGION = "region",
  USERNAME = "username",
  REDIRECT_TO = "redirect_to",
  EMAIL = "email",
  CODE = "code",
  EXPIRE_AT = "expireAt",
  PREV_ERROR = "prevError",
}

export enum UIUserStatus {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
}
